<script>
    import { onMount, onDestroy, createEventDispatcher } from 'svelte'
    //import date from 'date-and-time'

    import { Link } from 'svelte-routing'
    import { FormGroup, Form, FormText, Input, Label, Button,
        Container, Row, Col,
        Card, CardSubtitle, CardText, CardBody, CardHeader, CardTitle } from 'sveltestrap'

    import SubtaskStore from '../../stores/subtasks'
    import AgentStore from '../../stores/agents'
    import ProjectStore from '../../stores/projects'

    const dispatch = createEventDispatcher()

    export let id = null
    export let location = null
    export let pageTitle = null
    export let task = null
    let changes = {}
    let trackChanges = false

    let subtasksDict = {}
    let agentsDict = {}

    const unsubscribeSubtasks = SubtaskStore.subscribe(subtasks => {
        subtasksDict = subtasks
    })

    const unsubscribeAgents = AgentStore.subscribe(agents => {
        agentsDict = agents
    })

    onDestroy(() => {
        if (unsubscribeSubtasks)
            unsubscribeSubtasks()
        if (unsubscribeAgents)
            unsubscribeAgents()
    })

    onMount(() => trackChanges = true)

    const track = {
        get: () => changes,
        task: (field) => {
            changes[field] = task[field]
        },
        address: (field) => {
            if (!changes['address'])
                changes['address'] = {}
            changes['address'][field] = task['address'][field]
        }
    }

    const onSave = () => {
        if (changes.subtasks) {
            changes.subtasks = changes.subtasks.map(id => subtasksDict[id])
        }
        dispatch('submit', changes)
    }

</script>

<style>
    .cardHeader :global(.card-header) {
        background-color: #fff;
        font-weight: bold;
    }
    .subtaskContainer :global(.container) {
        background-color: #fff;
    }
    .inline-title :global(.card-subtitle) {
        display: inline;
        font-weight: bold;
    }
    .sidebox {
        border: 1px;
        float: left;
        vertical-align: middle;
        padding-left: 12px;
        padding-right: 12px;
    }
</style>

<!--form on:submit|preventDefault={save}-->
<Container class="mt-4">
    <Row>
        <Col><Link on:click={() => window.history.back()}><i class="fa fa-arrow-left"></i><span style="margin-left: 8px">Back</span></Link></Col>
    </Row>
    <Row>
        <Col>
            <div class="cardHeader">
                <Card>
                    <CardHeader>
                        <h4 class="float-left">{pageTitle}</h4>
                    </CardHeader>
                    <CardBody>
                            <FormGroup>
                                <Label for="project">Project</Label>
                                <select class="custom-select" name="stprojectate" bind:value={task.projectId} on:change={() => track.task('projectId')}>
                                    {#each Object.keys($ProjectStore) as projectKey}
                                    <option value={projectKey}>{$ProjectStore[projectKey].name}</option>
                                    {/each}
                                </select>
                            </FormGroup>
                            <FormGroup>
                                <Label for="title">Title</Label>
                                <Input id="title" placeholder="Title" bind:value={task.title} on:change={() => track.task('title')} />
                                <Label for="address1">Address</Label>
                                <Input id="address1" placeholder="Address 1" bind:value={task.address.address1} on:change={() => track.address('address1')} />
                                <Label for="address2">Address</Label>
                                <Input id="address2" placeholder="Address 2" bind:value={task.address.address2} on:change={() => track.address('address2')} />
                                <Label for="postalCode">Postal code</Label>
                                <Input id="postalCode" placeholder="Postal Code" bind:value={task.address.postalCode} on:change={() => track.address('postalCode')} />
                                <Label for="city">City</Label>
                                <Input id="city" placeholder="City" bind:value={task.address.city} on:change={() => track.address('city')} />
                                <Label for="country">Country</Label>
                                <Input id="country" placeholder="Country" bind:value={task.address.country} on:change={() => track.address('country')} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="geolocation">Geolocation</Label>
                                <Input id="geolocation" placeholder="Latitude,Longitude" bind:value={task.geolocation} on:change={() => track.task('geolocation')}/>
                            </FormGroup>
                            <FormGroup>
                                <Label for="summary">Summary</Label>
                                <Input type="textarea" id="summary" placeholder="Short summary" bind:value={task.summary} rows=5 on:change={() => track.task('summary')} />
                                <Label for="description">Description</Label>
                                <Input type="textarea" id="description" placeholder="Detailed description" bind:value={task.description} rows=20 on:change={() => track.task('description')}/>
                            </FormGroup>
                        <Button color="primary" on:click={onSave}>Save</Button>
                    </CardBody>
                </Card>
            </div>
        </Col>
        <Col>
            <Container>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                    <FormGroup>
                                        <Label for="expire">Expire date</Label>
                                        <Input type="date" name="expire" id="expire" placeholder="Expire date" bind:value={task.expire} on:change={() => track.task('expire')} />
                                        <Label for="state">State</Label>
                                        <select class="custom-select" name="state" bind:value={task.state} on:change={() => track.task('state')} >
                                            <option value="CLOSED">Closed</option>
                                            <option value="OPEN">Open</option>
                                            <option value="SUBMITTED">Submitted</option>
                                        </select>
                                    </FormGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                    <FormGroup>
                                        <Label for="agent">Agent</Label>
                                        <select class="custom-select" name="agent" bind:value={task.agentId} on:change={() => track.task('agentId')} >
                                             {#each Object.keys(agentsDict) as agentKey}
                                             <option value={agentKey}>{agentsDict[agentKey].name}</option>
                                             {/each}
                                        </select>
                                    </FormGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div class="subtaskContainer">
                            <Container class="mt-3">
                                <Row>
                                    <Col>
                                        <h5 class="mt-3 float-left">Add subtasks</h5>
                                    </Col>
                                </Row>
                                <Row><Col>Choose subtasks to complete</Col></Row>

                                {#each Object.keys(subtasksDict) as subtaskKey}
                                <Row class="pb-3">
                                    <Col>
                                        <div class="inline-title">
                                        <Card id={subtaskKey} class="mt-3">
                                            <CardBody>
                                                <div class="sidebox">
                                                    <input type="checkbox" bind:group={task.subtasks} value={subtaskKey} on:change={() => track.task('subtasks')} />
                                                </div>
                                                <div style="margin-left: 12px">
                                                    <CardSubtitle class="font-weight-bold">{subtasksDict[subtaskKey].title}</CardSubtitle>
                                                    <CardText>{subtasksDict[subtaskKey].description}</CardText>
                                                </div>
                                            </CardBody>
                                        </Card>
                                        </div>
                                    </Col>
                                </Row>
                                {/each}

                            </Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Col>
    </Row>
</Container>
<!--/form-->
